import { cloneElement } from 'react';
import { twJoin } from 'tailwind-merge';

function TooltipTrigger({ children }) {
  return cloneElement(children, {
    className: twJoin('peer', children.props?.className),
  });
}

export default TooltipTrigger;
